import React from 'react';
import Navigation from "../components/Navigation/Navigation";
import FrontendFooter from "../components/Layout/FrontendFooter";
import { Card, CardContent, Container, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import AboutBanner from "../assets/images/misson.jpg";
import Vision from "../assets/images/vission.svg";
import Mission from "../assets/images/mission.svg";
import CoreValues from "../assets/images/core.svg";
 





const VisionMission = () => {
  return (
    <div className="fp-wrapper app-container">
      <Navigation />

      <section className="inner-banner text-white" style={{ backgroundImage: `url(${AboutBanner})` }}>
        <div className="home-container">
          <h1 className="page-title">Vision & Mission and Core Values</h1>
          <p>To be the most trusted and innovative partner</p>
        </div>
      </section>
      
      <section className="about-section inner-page-content">
        <Container maxWidth="lg">


<Box sx={{marginBottom: "30px"}}>

<Card elevation={6}>
                <CardContent style={{ padding: "50px" }}>

                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                <Grid size={{ xs: 2, md: 2 }}>


                  <img src={Vision} alt="Vision" className='w-100' />
                  </Grid>
                  
                  <Grid size={{ xs: 9, md: 9 }}>
                  <h2>Our Vision</h2>
                  <p>
                    To be the most trusted and innovative partner in the steel industry, 
                    delivering exceptional value to our customers and stakeholders through 
                    sustainable practices and cutting-edge solutions.
                  </p>
                  </Grid>
                  
                  
                  </Grid>
                
                  
                </CardContent>
              </Card>

</Box>



<Box sx={{marginBottom: "30px"}}>

<Card elevation={6}>
                <CardContent style={{ padding: "50px" }}>

                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                <Grid size={{ xs: 2, md: 2 }} order={{ xs: 1, md: 2 }}>


                  <img src={Mission} alt="Vision" className='w-100' />
                  </Grid>
                  
                  <Grid size={{ xs: 9, md: 9 }} order={{ xs: 2, md: 1 }}>
                  <h2>Our Mission</h2>
                  <p>
                    To provide high-quality steel products and services that meet the evolving 
                    needs of our customers, while maintaining the highest standards of 
                    environmental responsibility and operational excellence.
                  </p>
                  </Grid>
                  
                  
                  </Grid>
                
                  
                </CardContent>
              </Card>

</Box>





<Box sx={{marginBottom: "30px"}}>

<Card elevation={6}>
                <CardContent style={{ padding: "50px" }}>

                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                <Grid size={{ xs: 2, md: 2 }}>


                  <img src={CoreValues} alt="Vision" className='w-100' />
                  </Grid>
                  
                  <Grid size={{ xs: 9, md: 9 }}>
                  <h2>Core Objectives</h2>
                  <ol className="list-disc" style={{ listStyleType: 'lower-alpha' }}>
                    <li>Enquiry-Driven Engagement: Enable customers to easily raise enquiries for steel products through a smartphone app or website.</li>
                    <li>Swift Response: Offer quick and customized quotations to users through an efficient admin panel.</li>
                    <li>Transparent Communication: Promote clarity in pricing, availability, and delivery timelines.</li>
                    <li>Digital First: Promote digital transformation in the traditionally manual steel enquiry process.</li>
                  </ol>
                  </Grid>
                  
                  
                  </Grid>
                
                  
                </CardContent>
              </Card>

</Box>





       
        </Container>
      </section>

      <FrontendFooter />
    </div>
  );
};

export default VisionMission;